<template>
    <div class="app-wrapper" :class="classObj" :style="{ '--current-color': theme }">
        <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
        <sidebar class="sidebar-container"  v-if="!sidebar.hide"  />
        <div  class="main-container">
            <div :class="{ 'fixed-header': fixedHeader }"   v-if="$store.state.headshow">
                <navbar  ref="navbarcomponent"    />
                <tags-view v-if="needTagsView" />
        </div>
        <app-main />
        </div>
   
    </div>
</template>

<script>
import { AppMain,Navbar,Sidebar,TagsView} from './components';
import { mapState } from 'vuex';
import variables from '@/assets/styles/variables.module.scss';
import ResizeMixin from './mixin/ResizeHandler.js';
export default {
    name: 'Layout',
    components: {
        AppMain,Navbar,Sidebar,TagsView
    },
    mixins: [ResizeMixin],
    computed: {
        ...mapState({
            theme: (state) => state.settings.theme,
            sideTheme: (state) => state.settings.sideTheme,
            sidebar: (state) => state.app.sidebar,
            device: (state) => state.app.device,
            needTagsView: (state) => state.settings.tagsView,
            fixedHeader: (state) => state.settings.fixedHeader,
            txImShow: (state) => state.user.txImShow
        }),
        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === 'mobile'
            }
        },
        variables() {
            return variables
        }
    },
    data() {
        return {
            fixedHeader:true,
            needTagsView:true
        }
    },
    mounted() {

    },
    watch: {
        $route(to, from) {
            console.log(to.path)
        }
    },
    methods: {
    
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/mixin.scss';
@import '@/assets/styles/variables.module.scss';
.fixed-header {
    // position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    // width: calc(100% - #{$base-sidebar-width});
    transition: width 0.28s;
}
.hideSidebar .fixed-header {
    width: calc(100% - 54px);
}

.sidebarHide .fixed-header {
    width: calc(100%);
}

.mobile .fixed-header {
    width: 100%;
}
.app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
        position: fixed;
        top: 0;
    }
}
</style>
